import { ExternalLink } from "lucide-react";
import { ConsentToggle } from "@/components/t4r/learners/ConsentPill";

const Row = ({ label, value, testId }) => (
  <div className="min-w-0"><p className="text-[10px] uppercase tracking-wide text-slate-400">{label}</p><p className="break-words text-xs text-slate-800" data-testid={testId}>{value || "—"}</p></div>
);

export const EoiDetails = ({ learner, onChanged }) => (
  <div className="space-y-2 rounded-lg border border-border p-3" data-testid="eoi-details">
    <div className="flex items-center justify-between">
      <p className="text-xs font-semibold">Application (EOI) details</p>
      <ConsentToggle learner={learner} onChanged={onChanged} />
    </div>
    {learner.eoi && (
      <div className="grid grid-cols-2 gap-2">
        <Row label="Phone" value={learner.eoi.phone} testId="eoi-phone" />
        <Row label="Submitted" value={learner.eoi.submission_date} testId="eoi-submitted" />
        <div className="col-span-2"><Row label="Address" value={learner.eoi.address} testId="eoi-address" /></div>
        <Row label="Signed" value={learner.eoi.signature_date} testId="eoi-signed" />
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-wide text-slate-400">Signature</p>
          {learner.eoi.signature_url
            ? <a href={learner.eoi.signature_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-medium text-green-800 hover:underline" data-testid="eoi-signature-link">Open signature <ExternalLink size={10} /></a>
            : <p className="text-xs text-slate-800">—</p>}
        </div>
      </div>
    )}
  </div>
);
